/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var SecurityKeyBIcon20Solid = forwardRef('SecurityKeyBIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.25 15.416a5.418 5.418 0 0 0 5.006-3.344.588.588 0 0 1 .983-.087l.583.748c.319.41.93.43 1.277.044l.67-.745a.833.833 0 0 1 1.261.025l.586.706a.833.833 0 0 0 1.27.016l1.66-1.906a.833.833 0 0 0 .026-1.064l-1.45-1.837a1.25 1.25 0 0 0-.982-.476h-6.086a5.416 5.416 0 1 0-4.804 7.92Zm0-3.333a2.083 2.083 0 1 0 0-4.166 2.083 2.083 0 0 0 0 4.166Z" })));
});
